import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import galleryWidgetIcon from "../../assets/images/gallery_widget.svg";

Scrivito.provideEditingConfig("AlbumGalleryWidget", {
  title: "Album Gallery",
  thumbnail: galleryWidgetIcon,
  attributes: localizeAttrList(["images"], "AlbumGalleryWidget"),
  properties: ["images"],
});
